export default "__VITE_ASSET__942d661c__"